import React, { useState, useEffect } from 'react';
import { Spin, message, Table } from 'antd';
import { red_vial } from '../../../services/perfiles/conponentesServices';
import './tablaG.css';
import { Pie } from 'react-chartjs-2';


const RedVialC = ({ municipioId, imganevial }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [chartDataGroups, setChartDataGroups] = useState(null);
    const [chartDataGender, setChartDataGender] = useState(null);
    useEffect(() => {
        if (municipioId) {
            fetchData();
        }

    }, [municipioId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await red_vial(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    setData(fetchedData);
                    prepareChartData(fetchedData);

                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const estadoRedColumns = [
        { title: 'Estado de la Red', dataIndex: 'estado', key: 'estado', className: 'filaP' },
        { title: 'Porcentaje', dataIndex: 'porcentaje', key: 'porcentaje', className: 'filaP' },
    ];

    const viasColumns = [
        { title: 'Estado de las Vías', dataIndex: 'estado', key: 'estado', className: 'filaP' },
        { title: 'Porcentaje', dataIndex: 'porcentaje', key: 'porcentaje', className: 'filaP' },
    ];

    const getEstadoRedData = (item) => [
        { estado: 'Red en Mal Estado', porcentaje: item.porc_estado_red_malo, className: 'filaP' },
        { estado: 'Red en Estado Regular', porcentaje: item.porc_estado_red_regular, className: 'filaP' },
        { estado: 'Red en Buen Estado', porcentaje: item.porc_estado_red_bueno, className: 'filaP' },
    ];

    const getViasData = (item) => [
        { estado: 'Vías en Mejoramiento', porcentaje: item.porc_vias_mejoramiento, className: 'filaP' },
        { estado: 'Vías Pavimentadas', porcentaje: item.porc_vias_pavimentadas, className: 'filaP' },
        { estado: 'Vías Afirmadas', porcentaje: item.porc_vias_afirmado, className: 'filaP' },
        { estado: 'Vías de Tierra', porcentaje: item.porc_vias_tierra, className: 'filaP' },
    ];
    const prepareChartData = (data) => {
        if (data.length > 0) {
            const item = data[0];
            setChartDataGroups({
                labels: ['Red en Mal Estado', 'Red en Estado Regular', 'Red en Buen Estado'],
                datasets: [
                    {
                        data: [item.porc_estado_red_malo, , item.porc_estado_red_regular, item.porc_estado_red_bueno],
                        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
                    },
                ],
            });
            setChartDataGender({
                labels: ['Vías en Mejoramiento', 'Vías Pavimentadas', 'Vías Afirmadas', 'Vías de Tierra'],
                datasets: [
                    {
                        data: [item.porc_vias_mejoramiento, item.porc_vias_pavimentadas, item.porc_vias_afirmado, item.porc_vias_tierra,],
                        backgroundColor: ['#FF6384', '#36A2EB', '#4BC0C0', '#0dcaf0'],
                    },
                ],
            });
        }
    };
    return (
        <div className="page-content">
            {loading ? (
                <Spin size="large" />
            ) : data.length > 0 ? (
                data.map(item => (
                    <div key={item.idinformacion}>
                        <div className="section">
                            <h3>3. RED VIAL</h3>
                            <p style={{ columnCount: 2, columnGap: '20px' }}>{item.descripcion_estad_vial}</p>
                            <p>{item.fuente}</p>
                        </div>
                        <div className="mapaminero">
                            <img className="mapa_politicoimg" src={imganevial} alt="Mapa vial" />
                        </div>
                        <div className="section">
                            <h3>Estado de la Red Vial</h3>
                            <Table
                                columns={estadoRedColumns}
                                dataSource={getEstadoRedData(item)}
                                rowKey="estado"
                                pagination={false}
                            />
                        </div>
                        <div className="section">
                            <h3>Estado de las Vías</h3>
                            <Table
                                columns={viasColumns}
                                dataSource={getViasData(item)}
                                rowKey="estado"
                                pagination={false}
                            />
                        </div>
                        <div className="chart-containerSisben ">
                            <div className="chart-Sisben">
                                <h4>Estado de la Red Vial</h4>
                                {chartDataGroups && <Pie data={chartDataGroups} />}
                            </div>

                            <div className="chart-Sisben">
                                <h4>Estado de las Vías</h4>
                                {chartDataGender && <Pie data={chartDataGender} />}
                            </div>
                        </div>
                    </div>
                ))
            ) : (
                <p>No hay datos disponibles para este municipio.</p>
            )}
        </div>
    );
};

export default RedVialC;
